import React from "react";
import DayColumn from "./DayColumn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKitchenSet } from "@fortawesome/free-solid-svg-icons";

const WeeklyPlanDisplay = React.memo(({ 
  weeklyPlan, 
  dayTotals, 
  onViewRecipe, 
  onEditRecipe, 
  onDeleteRecipe, 
  currentPlanType,
  onCopyDay,
  onClearDay,
  onClearMeal,
  onClearAllDays,
  onShowPrepList,
  hasPrepItems,
  onSaveWeek,
  onLoadWeek
}) => {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "None"];

  console.log("WeeklyPlanDisplay debug:", {
    weeklyPlanLength: weeklyPlan.length,
    currentPlanType,
    hasPrepItems,
    showButton: weeklyPlan.length > 0 && currentPlanType === 'current' && hasPrepItems
  });

  return (
    <div className="container">
      <div className="weekly-plan-header">
        <div className="info-message">
          <small className="text-muted">
            <i className="fas fa-info-circle"></i> Total calories are listed per serving. 
            Modifying entries may re-add ingredients to your shopping list if they were previously crossed off.
          </small>
        </div>
        {/* Always rendered: loading a saved week matters most when the plan is
            empty, so this group must not sit behind the length check below. */}
        <div className="week-library-buttons">
          <button
            className="btn btn-outline-primary btn-sm save-week-btn me-2"
            onClick={onSaveWeek}
            disabled={weeklyPlan.length === 0}
            title={
              weeklyPlan.length === 0
                ? "Add some recipes before saving this week"
                : "Save this week's plan so you can load it again later"
            }
          >
            <i className="fas fa-bookmark me-1"></i>
            Save This Week
          </button>
          <button
            className="btn btn-outline-primary btn-sm load-week-btn"
            onClick={onLoadWeek}
          >
            <i className="fas fa-folder-open me-1"></i>
            Load Saved Week
          </button>
        </div>
        {weeklyPlan.length > 0 && (
          <div className="header-buttons">
            {currentPlanType === 'current' && (
              <button
                className="btn btn-outline-warning btn-sm prep-list-btn me-2"
                onClick={onShowPrepList}
              >
                <FontAwesomeIcon icon={faKitchenSet} className="me-1" />
                Weekly Prep List {!hasPrepItems && "(0)"}
              </button>
            )}
            <button
              className="btn btn-outline-danger btn-sm clear-all-days-btn"
              onClick={onClearAllDays}
            >
              <i className="fas fa-trash-alt me-1"></i>
              Clear All Days
            </button>
          </div>
        )}
      </div>
      <div className="row">
        {days.map((day) => (
          <DayColumn
            key={day}
            day={day}
            recipes={weeklyPlan}
            dayTotals={dayTotals}
            onViewRecipe={onViewRecipe}
            onEditRecipe={onEditRecipe}
            onDeleteRecipe={onDeleteRecipe}
            currentPlanType={currentPlanType}
            onCopyDay={onCopyDay}
            onClearDay={onClearDay}
            onClearMeal={onClearMeal}
          />
        ))}
      </div>
    </div>
  );
});

export default WeeklyPlanDisplay;